import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Truck } from "lucide-react";
import { SUBURBS } from "../lib/suburbs";

export default function ServiceArea() {
  return (
    <section
      id="area"
      data-testid="service-area-section"
      className="bg-[#0D0D0D] py-24 lg:py-32 border-t border-[#222]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] font-bold mb-4">
              [ 04 ] Where We Work
            </div>
            <h2 className="font-heading uppercase text-white text-5xl lg:text-7xl leading-[0.9] tracking-tighter mb-8">
              South East VIC<br />
              <span className="text-[#FF5A00]">+ Gippsland.</span>
            </h2>
            <p className="text-[#A3A3A3] text-lg leading-relaxed mb-10">
              Based locally and covering everything from the bay through to
              Bairnsdale. Tap your suburb below for a dedicated quote page — or
              flick us a message if you're not sure we cover your patch.
            </p>
            <div className="space-y-px bg-[#333]">
              {[
                { icon: MapPin, label: "Home Base", value: "South East Victoria" },
                { icon: Clock, label: "Response Time", value: "Same business day" },
                { icon: Truck, label: "Travel", value: "90-min radius incl." },
              ].map((it, i) => (
                <div key={i} className="bg-[#0D0D0D] flex items-center gap-5 p-5">
                  <it.icon className="w-6 h-6 text-[#FF5A00]" strokeWidth={1.5} />
                  <div>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">
                      {it.label}
                    </div>
                    <div className="font-heading text-white text-xl uppercase tracking-tight">
                      {it.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.3em] uppercase text-[#A3A3A3] mb-4">
              Suburbs we regularly service — click for a local quote page →
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-[#333]">
              {SUBURBS.map((s) => (
                <Link
                  key={s.slug}
                  to={`/fencing/${s.slug}`}
                  data-testid={`suburb-link-${s.slug}`}
                  className="bg-[#0D0D0D] hover:bg-[#1A1A1A] hover:text-[#FF5A00] transition-colors px-4 py-5 text-white font-body text-sm tracking-wide border-l-2 border-transparent hover:border-[#FF5A00]"
                >
                  {s.name}
                </Link>
              ))}
              <div className="bg-[#FF5A00] text-black px-4 py-5 font-heading uppercase tracking-widest text-sm">
                + Your Suburb?
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
